<template>
  <v-container fluid tag="section">
    <div v-if="item.length === 0">
      <img :src="require('@/assets/images/empty.png')" height="300" :width="$isMobile ? '100%' : 300"/>
    </div>
    <v-row v-for="(itm, idx) in item" :key="idx">
      <v-col cols="12"  v-if="idx !== 0">
        <v-divider class="mb-3"></v-divider>
      </v-col>
      <v-col cols="12" :md="mini ? 6 : 4" :class="$isMobile ? 'size-13' : ''">
        网站名称：<span class="font-weight-black">{{itm.webName}}</span>
      </v-col>
      <v-col cols="12" :md="mini ? 6 : 4" :class="$isMobile ? 'size-13' : ''">
        网站地址：<span class="font-weight-black">{{itm.webPath}}</span>
      </v-col>
      <v-col cols="12" :md="mini ? 6 : 4" :class="$isMobile ? 'size-13' : ''">
        登陆账号：<span class="font-weight-black">{{itm.account}}</span>
      </v-col>
      <v-col cols="12" :md="mini ? 6 : 4" :class="$isMobile ? 'size-13' : ''">
        登陆密码：<span class="font-weight-black">{{itm.password}}</span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'CustomerWebsDetail',
    components: {
    },
    props: {
      item: {
        type: Array,
        default: () => ([])
      },
      mini: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
      }
    }
  }
</script>

<style>
</style>
